import * as api from '../../api';

export const fetchNewValidation = api.fetchActions('validate-intake', 'fetch-new-validation-result');
export const fetchEditValidationActions = api.fetchActions('validate-intake', 'fetch-edit-validation-result');
export const fetchExistingValidationActions = api.fetchActions('validate-intake', 'fetch-validation-result');

export const actionTypes = {
  ...fetchNewValidation.actionTypes,
  ...fetchEditValidationActions.actionTypes,
  ...fetchExistingValidationActions.actionTypes,
  INVALIDATE_EDIT_VALIDATION: 'validate-intake.invalidate-edit',
  INVALIDATE_NEW_VALIDATION: 'validate-intake.invalidate-new',
}

export function shouldValidateNew(siteId, programId, value) {
  return api.shouldExecute(['validateIntake', 'newFormValidation'],
  validateNewIntakeForm(siteId, programId, value));
}

export function validateNewIntakeForm(siteId, programId, value) {
  return (dispatch) => {
    const returnValue = {
      siteId,
      programId,
      ...(!!value ? value.toObject() : {})
    };

    return dispatch(api.postThunk(`/intake/validate-new`, returnValue, fetchNewValidation));
  }
}

export function shouldValidateEdit(formId, siteId, programId, value) {
  return api.shouldExecute(['validateIntake', 'editFormValidation', formId],
    validateEditedIntakeForm(formId, siteId, programId, value));
}

export function validateEditedIntakeForm(formId, siteId, programId, value) {
  return (dispatch) => {
    const returnValue = {
      siteId,
      programId,
      ...(!!value ? value.toObject() : {})
    };

    return dispatch(api.postThunk(`/intake/validate-edit/${formId}`, returnValue, fetchEditValidationActions, { formId }));
  }
}

export const validateExistingIntakeForm = (formId) =>
 api.postThunk(`/intake/validate/${formId}`, null, fetchExistingValidationActions, { formId });

export function invalidateEditValidationResult(id) {
  return {
    type: actionTypes.INVALIDATE_EDIT_VALIDATION,
    formId: id
  }
}

export function invalidateNewValidationResult() {
  return {
    type: actionTypes.INVALIDATE_NEW_VALIDATION
  }
}
